/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PastiNonOrdinari } from './pasti-non-ordinari';


export interface ResocontoPastiDipendenti { 
    intestazione_scuola?: string;
    numero_pasti_docenti?: number;
    numero_pasti_personale_ata?: number;
    numero_pasti_personale_tecnico?: number;
    numero_pasti_collaboratori?: number;
    note_pasti_docenti?: string;
    note_pasti_personale_ata?: string;
    note_pasti_personale_tecnico?: string;
    note_pasti_collaboratori?: string;
    numero_minimo_pasti_da_fatturare?: number;
    pasti_non_ordinari_docenti?: Array<PastiNonOrdinari>;
    pasti_non_ordinari_personale_ata?: Array<PastiNonOrdinari>;
    pasti_non_ordinari_personale_tecnico?: Array<PastiNonOrdinari>;
    pasti_non_ordinari_collaboratori?: Array<PastiNonOrdinari>;
}

